(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.headerResizeObserver = new ResizeObserver(this.setHeaderHeight);
      this.headerResizeObserver.observe(this.header);
      this.announcementBar = document.querySelector('.announcement-bar-section');
      if (this.announcementBar) this.headerResizeObserver.observe(this.announcementBar);

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const announcement = document.querySelector('.announcement-bar-section');
      document.documentElement.style.setProperty('--ug-announcement-height', `${announcement ? Math.ceil(announcement.getBoundingClientRect().height) : 0}px`);
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.headerResizeObserver?.disconnect();
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ug-brand-index"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ug-brand-index')) {
    customElements.define('ug-brand-index', class extends HTMLElement {
      connectedCallback() {
        if (!window.matchMedia('(pointer: fine)').matches) return;
        const peek = this.querySelector('.ugb-peek');
        const img = peek && peek.querySelector('img');
        if (!peek) return;
        const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let x = 0, y = 0, frame = null;
        const move = () => { peek.style.transform = `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%)`; frame = null; };
        this.addEventListener('pointermove', (e) => {
          const r = this.getBoundingClientRect();
          x = e.clientX - r.left; y = e.clientY - r.top;
          if (!frame) frame = requestAnimationFrame(move);
        });
        this.querySelectorAll('.ugb-row').forEach((row) => {
          row.addEventListener('pointerenter', () => {
            if (!row.dataset.peek) { peek.classList.remove('is-on'); return; }
            if (img.getAttribute('src') !== row.dataset.peek) img.src = row.dataset.peek;
            peek.style.setProperty('--peek-accent', getComputedStyle(row).getPropertyValue('--row-accent'));
            peek.classList.add('is-on');
            if (!calm) peek.classList.toggle('is-tilt', !peek.classList.contains('is-tilt'));
          });
          row.addEventListener('pointerleave', () => peek.classList.remove('is-on'));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ug-collection-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ug-col-hero')) {
    customElements.define('ug-col-hero', class extends HTMLElement {
      connectedCallback() {
        this.calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.fine = window.matchMedia('(pointer: fine)').matches;
        if (!this.calm && this.fine) this.parallax();
        this.slides();
        this.counters();
        this.countdown();
      }
      disconnectedCallback() {
        clearTimeout(this.slideTimer);
        clearTimeout(this.fadeTimer);
        this.slideObserver?.disconnect();
        this.slideResize?.disconnect();
        clearInterval(this.clockTimer);
      }
      parallax() {
        let frame = null, x = 0, y = 0;
        this.spot = this.dataset.layout === 'brand' ? this.querySelector('[data-spot]') : null;
        const apply = () => {
          this.style.setProperty('--px', x.toFixed(3));
          this.style.setProperty('--py', y.toFixed(3));
          frame = null;
        };
        this.addEventListener('pointermove', (event) => {
          const r = this.getBoundingClientRect();
          x = ((event.clientX - r.left) / r.width) * 2 - 1;
          y = ((event.clientY - r.top) / r.height) * 2 - 1;
          if (this.spot) {
            const t = this.spot.getBoundingClientRect();
            this.spot.style.setProperty('--sx', (event.clientX - t.left).toFixed(0) + 'px');
            this.spot.style.setProperty('--sy', (event.clientY - t.top).toFixed(0) + 'px');
          }
          if (!frame) frame = requestAnimationFrame(apply);
        });
        this.addEventListener('pointerleave', () => { x = 0; y = 0; if (!frame) frame = requestAnimationFrame(apply); });
      }
      slides() {
        const wrap = this.querySelector('[data-slides]');
        const source = this.querySelector('[data-ugc-pool]');
        if (!wrap || !source || this.slideStarted) return;
        this.slideStarted = true;
        let pool;
        try { pool = JSON.parse(source.textContent); } catch (error) { return; }
        if (!pool.length) return;
        for (let i = pool.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [pool[i], pool[j]] = [pool[j], pool[i]];
        }
        const key = 'ug-hero-model:' + location.pathname;
        let previous;
        try { previous = sessionStorage.getItem(key); } catch (error) {}
        if (pool.length > 1 && String(pool[0].id) === previous) pool.push(pool.shift());
        pool = pool.slice(0, 5);
        let front = wrap.querySelector('.ugc-slide');
        let back = front.cloneNode(true);
        back.classList.remove('is-active');
        back.setAttribute('aria-hidden', 'true');
        back.setAttribute('tabindex', '-1');
        wrap.appendChild(back);
        let index = 0, busy = false, hovered = false, inView = true;
        const dots = this.querySelector('[data-dots]');
        const fitImage = async layer => {
          if (!window.ugProductFit) await new Promise(resolve => document.addEventListener('ug:product-fit-ready', resolve, {once:true}));
          await window.ugProductFit.fit(layer.querySelector('img'));
        };
        const prepare = async (layer, model) => {
          const image = layer.querySelector('img');
          window.ugProductFit?.reset(image);
          image.removeAttribute('srcset');
          image.loading = 'eager';
          image.crossOrigin = 'anonymous';
          delete image.dataset.ugOriginalImage;
          image.src = model.src;
          image.alt = model.title;
          layer.href = model.url;
          layer.querySelector('figcaption b').textContent = model.title;
          layer.querySelector('figcaption span').textContent = model.price;
          await image.decode();
          await fitImage(layer);
        };
        const remember = () => {
          this.dataset.ugHeroCurrent = String(pool[index].id);
          try { sessionStorage.setItem(key, String(pool[index].id)); } catch (error) {}
          if (dots) [...dots.children].forEach((dot,n) => dot.setAttribute('aria-pressed', String(n === index)));
        };
        const show = async next => {
          if (busy || !this.isConnected) return;
          busy = true;
          clearTimeout(this.slideTimer);
          next = (next + pool.length) % pool.length;
          try {
            await prepare(back, pool[next]);
            if (!this.isConnected) return;
            requestAnimationFrame(() => {
              front.classList.remove('is-active');
              back.classList.add('is-active');
              front.setAttribute('aria-hidden', 'true');
              front.setAttribute('tabindex', '-1');
              back.setAttribute('aria-hidden', 'false');
              back.removeAttribute('tabindex');
              index = next;
              remember();
              this.fadeTimer = setTimeout(() => {
                [front,back] = [back,front];
                busy = false;
                queue();
              }, this.calm ? 0 : 800);
            });
          } catch (error) { busy = false; queue(); }
        };
        const queue = () => {
          clearTimeout(this.slideTimer);
          if (this.calm || pool.length < 2 || !this.isConnected) return;
          prepare(back, pool[(index+1)%pool.length]).catch(() => {});
          this.slideTimer = setTimeout(() => {
            if (document.hidden || !inView || hovered || this.contains(document.activeElement)) { queue(); return; }
            show(index + 1);
          }, 6000);
        };
        if (dots) pool.forEach((model,n) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ugc-dot';
          button.setAttribute('aria-label', model.title);
          button.addEventListener('click', () => { if (n !== index) show(n); });
          dots.appendChild(button);
        });
        this.addEventListener('mouseenter', () => { hovered = true; });
        this.addEventListener('mouseleave', () => { hovered = false; });
        this.slideObserver = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; }, {threshold:.1});
        this.slideObserver.observe(wrap);
        this.slideResize = new ResizeObserver(() => { fitImage(front); fitImage(back); });
        this.slideResize.observe(wrap);
        prepare(front, pool[0]).then(() => { remember(); queue(); }).catch(() => {});
      }
      counters() {
        const els = [...this.querySelectorAll('[data-count]')];
        if (!els.length || this.calm || !('IntersectionObserver' in window)) return;
        const run = (el) => {
          const target = parseInt(el.dataset.count, 10);
          if (!target || target < 2) return;
          const start = performance.now(), dur = 1200;
          const step = (now) => {
            const t = Math.min(1, (now - start) / dur);
            el.textContent = Math.round(target * (1 - Math.pow(1 - t, 3)));
            if (t < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        };
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
        }, { threshold: 0.4 });
        els.forEach((el) => io.observe(el));
      }
      countdown() {
        const box = this.querySelector('[data-end]');
        if (!box) return;
        const raw = box.dataset.end.trim();
        const end = new Date(/^\d{4}-\d{2}-\d{2}$/.test(raw) ? raw + 'T23:59:59' : raw);
        const out = box.querySelector('[data-time]');
        if (isNaN(end) || end <= new Date()) return;
        const pad = (n) => String(n).padStart(2, '0');
        const tick = () => {
          let s = Math.max(0, Math.floor((end - new Date()) / 1000));
          if (s === 0) { box.hidden = true; clearInterval(this.clockTimer); return; }
          const d = Math.floor(s / 86400); s %= 86400;
          const h = Math.floor(s / 3600); s %= 3600;
          const m = Math.floor(s / 60); s %= 60;
          out.textContent = (d ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
        };
        tick();
        box.hidden = false;
        this.clockTimer = setInterval(tick, 1000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ug-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ug-tabs')) {
    customElements.define('ug-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        if (!this.tabs.length) return;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => {
            const last = this.tabs.length - 1;
            let next = null;
            if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
            if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = last;
            if (next === null) return;
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus();
          });
        });
        this.onBlockSelect = (event) => {
          const index = this.tabs.findIndex((tab) => tab.dataset.block === event.detail.blockId);
          if (index > -1) this.select(index);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
      select(index) {
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ug-reviews-mini"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ug-chat-mini')) {
    customElements.define('ug-chat-mini', class extends HTMLElement {
      connectedCallback() {
        const dialog = this.querySelector('dialog');
        if (!dialog || !dialog.showModal) return;
        const img = dialog.querySelector('img');
        this.addEventListener('click', (event) => {
          const shot = event.target.closest('.ugm-shot[data-full]');
          if (!shot) return;
          img.src = shot.dataset.full;
          this.last = shot;
          dialog.showModal();
        });
        dialog.querySelector('.ugr-close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
        dialog.addEventListener('close', () => { if (this.last) this.last.focus(); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ug-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ug-reviews')) {
    customElements.define('ug-reviews', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.ugr-dialog');
        this.dialogImg = this.dialog && this.dialog.querySelector('img');
        this.addEventListener('click', (event) => {
          const shot = event.target.closest('.ugr-shot[data-full]');
          if (shot && this.dialog && this.dialog.showModal) {
            this.dialogImg.src = shot.dataset.full;
            this.dialogImg.alt = shot.dataset.alt || '';
            this.lastShot = shot;
            this.dialog.showModal();
          }
        });
        if (this.dialog) {
          this.dialog.querySelector('.ugr-close').addEventListener('click', () => this.dialog.close());
          this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); });
          this.dialog.addEventListener('close', () => { if (this.lastShot) this.lastShot.focus(); });
        }
        this.countUp();
      }
      countUp() {
        const el = this.querySelector('.ugr-num[data-count]');
        if (!el || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const raw = el.dataset.count;
        const match = raw.match(/^(\D*)([\d.,]+)(.*)$/);
        if (!match) return;
        const prefix = match[1], suffix = match[3];
        const target = parseInt(match[2].replace(/[.,]/g, ''), 10);
        if (!target) return;
        const format = (n) => n.toLocaleString('sr-RS');
        el.textContent = prefix + '0' + suffix;
        const run = () => {
          const start = performance.now(), duration = 16000;
          const step = (now) => {
            const t = Math.min(1, (now - start) / duration);
            const eased = t;
            el.textContent = prefix + format(Math.round(target * eased)) + suffix;
            if (t < 1) requestAnimationFrame(step); else el.textContent = raw;
          };
          requestAnimationFrame(step);
        };
        const io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) { io.disconnect(); run(); }
        }, { threshold: 0.4 });
        io.observe(el);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ug-sale"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ug-sale-drop')) {
    customElements.define('ug-sale-drop', class extends HTMLElement {
      connectedCallback() {
        if (this.ugAbort) return;
        this.ugAbort = new AbortController();
        const signal = this.ugAbort.signal;
        this.ugTrack = this.querySelector('.ug-track');
        if (!this.ugTrack) return;
        this.ugPrev = this.querySelector('[data-ug-prev]');
        this.ugNext = this.querySelector('[data-ug-next]');
        this.ugBar = this.querySelector('.ug-progress span');
        this.ugReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.ugInteracted = false;
        const markInteracted = () => { this.ugInteracted = true; };
        ['pointerdown', 'focusin', 'keydown', 'wheel'].forEach(event => this.ugTrack.addEventListener(event, markInteracted, {signal, passive: true}));
        this.ugPrev.addEventListener('click', () => { markInteracted(); this.move(-1); }, {signal});
        this.ugNext.addEventListener('click', () => { markInteracted(); this.move(1); }, {signal});
        this.ugTrack.addEventListener('scroll', () => {
          if (this.ugFrame) return;
          this.ugFrame = requestAnimationFrame(() => { this.ugFrame = null; this.update(); });
        }, {signal, passive: true});
        this.ugTrack.addEventListener('keydown', event => {
          if (event.target !== this.ugTrack) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1); }
          if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.ugTrack.scrollTo({left: event.key === 'Home' ? 0 : this.ugTrack.scrollWidth, behavior: this.ugReduced.matches ? 'instant' : 'smooth'});
          }
        }, {signal});
        this.ugTrack.addEventListener('focusin', event => {
          const card = event.target.closest('.ug-item');
          if (!card) return;
          const itemRect = card.getBoundingClientRect();
          const trackRect = this.ugTrack.getBoundingClientRect();
          if (itemRect.left < trackRect.left || itemRect.right > trackRect.right) {
            this.ugTrack.scrollBy({left: itemRect.left - trackRect.left, behavior: 'instant'});
          }
        }, {signal});
        this.querySelector('.ug-controls').hidden = false;
        this.classList.add('ug-enhanced');
        this.ugResize = new ResizeObserver(() => this.update());
        this.ugResize.observe(this.ugTrack);
        window.addEventListener('pagehide', markInteracted, {signal});
        window.addEventListener('pageshow', event => {
          if (!event.persisted) return;
          this.update();
        }, {signal});
        this.update();
        this.randomize(signal).finally(() => {
          if (signal.aborted) return;
          this.update();
          this.reveal();
        });
      }
      move(direction) {
        const item = this.ugTrack.querySelector('.ug-item');
        if (!item) return;
        const gap = parseFloat(getComputedStyle(this.ugTrack).columnGap) || 0;
        this.ugTrack.scrollBy({left: direction * (item.getBoundingClientRect().width + gap), behavior: this.ugReduced.matches ? 'instant' : 'smooth'});
      }
      update() {
        const track = this.ugTrack;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const left = Math.max(0, Math.min(max, track.scrollLeft));
        this.ugPrev.disabled = left <= 2;
        this.ugNext.disabled = max - left <= 2;
        const visible = track.scrollWidth ? Math.min(1, track.clientWidth / track.scrollWidth) : 1;
        const progress = max > 0 ? visible + (1 - visible) * left / max : 1;
        this.ugBar.style.width = `${progress * 100}%`;
      }
      reveal() {
        if (this.ugRevealed || this.ugReduced.matches) return;
        this.ugTrack.querySelectorAll('.ug-item').forEach((card, index) => card.style.setProperty('--ug-delay', `${Math.min(index, 4) * 65}ms`));
        this.ugObserver = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.ugRevealed = true;
          this.classList.add('ug-enter');
          this.ugObserver.disconnect();
        }, {threshold: .08});
        this.ugObserver.observe(this);
      }
      async randomize(signal) {
        const pool = this.querySelector('[data-ug-pool]');
        if (!pool || this.dataset.random !== 'true') return;
        const initial = [...pool.content.querySelectorAll('.ug-item')];
        for (let i = initial.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [initial[i], initial[j]] = [initial[j], initial[i]];
        }
        this.ugTrack.replaceChildren(...initial.slice(0, Number(this.dataset.count)).map(card => card.cloneNode(true)));
        const total = Math.min(Number(pool.dataset.total), 25000);
        const count = Math.min(Number(this.dataset.count), total);
        const pageSize = Number(pool.dataset.pageSize);
        if (!total || !count || !pageSize) return;
        const indices = new Set();
        for (let j = total - count; j < total; j++) {
          const candidate = Math.floor(Math.random() * (j + 1));
          indices.add(indices.has(candidate) ? j : candidate);
        }
        const selected = [...indices];
        for (let i = selected.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [selected[i], selected[j]] = [selected[j], selected[i]];
        }
        const cards = new Map();
        const collect = template => template.content.querySelectorAll('[data-ug-index]').forEach(card => cards.set(Number(card.dataset.ugIndex), card));
        collect(pool);
        const pages = [...new Set(selected.filter(index => !cards.has(index)).map(index => Math.floor(index / pageSize) + 1))];
        const requestAbort = new AbortController();
        const abortRequest = () => requestAbort.abort();
        signal.addEventListener('abort', abortRequest, {once: true});
        const timeout = setTimeout(abortRequest, 10000);
        try {
          const queue = pages.slice();
          const worker = async () => {
            while (queue.length) {
              const page = queue.shift();
              const url = new URL(window.location.href);
              url.hash = '';
              url.searchParams.delete('sections');
              url.searchParams.set('section_id', this.dataset.sectionId);
              url.searchParams.set(pool.dataset.pageParam, String(page));
              const response = await fetch(url, {signal: requestAbort.signal, credentials: 'same-origin'});
              if (!response.ok) throw new Error('Section unavailable');
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              const fetchedPool = doc.getElementById(this.id)?.querySelector('[data-ug-pool]');
              if (!fetchedPool || Number(fetchedPool.dataset.currentPage) !== page) throw new Error('Page unavailable');
              collect(fetchedPool);
            }
          };
          await Promise.all(Array.from({length: Math.min(3, pages.length)}, worker));
          if (signal.aborted || !this.isConnected || this.ugInteracted || !selected.every(index => cards.has(index))) return;
          const fragment = document.createDocumentFragment();
          selected.forEach(index => fragment.appendChild(cards.get(index).cloneNode(true)));
          this.ugTrack.replaceChildren(fragment);
          this.ugTrack.scrollLeft = 0;
        } catch (error) {
          requestAbort.abort();
        } finally {
          clearTimeout(timeout);
          signal.removeEventListener('abort', abortRequest);
        }
      }
      disconnectedCallback() {
        this.ugAbort?.abort();
        this.ugAbort = null;
        this.ugResize?.disconnect();
        this.ugObserver?.disconnect();
        if (this.ugFrame) cancelAnimationFrame(this.ugFrame);
        this.ugFrame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ug-season-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ug-season-hero')) {
    customElements.define('ug-season-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.motionReady) return;
        this.motionReady = true;
        const button = this.querySelector('.ug-season__motion');
        if (!button) return;
        button.hidden = false;
        const products = JSON.parse(this.querySelector('[data-season-products]').textContent);
        const positions = {autumn:0,winter:0};
        this.rotation = setInterval(() => {
          if(this.hasAttribute('data-paused') || document.hidden || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          for(const season of ['autumn','winter']) {
            const items=products[season],feature=this.querySelector('.ug-season__feature--'+season);
            if(!feature || items.length<2 || feature.matches(':hover,:focus-within')) continue;
            const item=items[positions[season]++ % items.length],preload=new Image();
            preload.onload=()=>{
              if(!this.isConnected || this.hasAttribute('data-paused'))return;
              const image=feature.querySelector('img');image.removeAttribute('srcset');image.src=item.image;image.alt=item.title;
              feature.href=item.url;feature.querySelector('.ug-season__feature-bottom strong').textContent=item.brand;
              feature.querySelector('.ug-season__feature-bottom>span').textContent=item.title.replace(/^UGG /,'');
            };
            preload.src=item.image;
          }
        },4000);
        button.addEventListener('click', () => {
          const paused = this.toggleAttribute('data-paused');
          button.setAttribute('aria-pressed', String(paused));
          button.textContent = paused ? this.dataset.play : this.dataset.pause;
        });
      }
      disconnectedCallback(){clearInterval(this.rotation);this.motionReady=false;}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ug-watch-studio"] && !Shopify.designMode) return;
  try {
    
if (!window.ugWatchStudioBound) {
  window.ugWatchStudioBound = true;
  async function addWatches(root, button, items) {
    if (button.disabled) return;
    const error = root.querySelector('[data-watch-error]');
    const label = button.textContent;
    button.disabled = true;
    button.textContent = root.dataset.loading;
    if (error) error.hidden = true;
    try {
      const response = await fetch(root.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(root.dataset.error);
      window.location.assign(root.dataset.cartUrl);
    } catch (problem) {
      if (error) {error.textContent = root.dataset.error; error.hidden = false; error.scrollIntoView({block:'center'});}
      button.disabled = false;
      button.textContent = label;
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target.closest('.ug-watch-form');
    if (!form) return;
    const root = form.closest('[data-watch-studio]');
    event.preventDefault();
    addWatches(root, form.querySelector('button[type="submit"]'), [{id:form.querySelector('[name="id"]').value,quantity:1}]);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-watch-bundle]');
    if (!button) return;
    addWatches(button.closest('[data-watch-studio]'), button, [{id:button.dataset.black,quantity:1},{id:button.dataset.white,quantity:1}]);
  });
}

  } catch(e) { console.error(e); }
})();
})();
